// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const homepageWidgetsClient = createTypedClient();
export const createHomepageWidgetsClient = (config) => createTypedClient(config);
